import { PaymentInfo } from "@/types/payment.type";

export function verifyWalletId(payments: PaymentInfo[]): string | null {
  try {
    const walletIds = payments.map(payment => {
      const historyData = payment.history && payment.history.length > 0
        ? payment.history[payment.history.length - 1]?.data
        : undefined;
      return historyData?.split?.[0]?.walletId;
    }).filter(Boolean) as string[]; // Type assertion após filtrar

    // Verifica se todas as walletIds são iguais
    const uniqueWalletIds = [...new Set(walletIds)];

    if (uniqueWalletIds.length === 1) {
      // Todas as walletIds são iguais, pode usar
      const walletId = uniqueWalletIds[0];
      return walletId;
    } else if (uniqueWalletIds.length > 1) {
      // Há walletIds diferentes
      return null; // ou throw new Error()
    } else {
      // Nenhum pagamento tem walletId
      return null;
    }
  } catch (error) {
    console.error("❌ Erro ao verificar walletId:", error);
    return null;
  }
}